import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import {
  createExportFailedStatus,
  createExportSuccessfulStatus,
} from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* exportReportsStatus(action) {
  try {
    const url = `${BACKEND_URL}/proxy/report/v1/reports/${action.payload.id}`;
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true);
    const body = yield getBodyJson(dataResponse, {});
    const report = body?.data || null;

    if (dataResponse.status === OK && report) {
      yield put(createExportSuccessfulStatus(report));
      yield call(resolveActionPromise(action, report));
    } else {
      yield put(createExportFailedStatus());
      yield call(rejectActionPromise(action, body));
    }
  } catch (e) {
    yield put(createExportFailedStatus());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
